import React from 'react';
import PropTypes from 'prop-types';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import IndentedCardHeader from '../../../components/IndentedCardHeader/IndentedCardHeader';
import ViewMoreLink from '../../../components/ViewMoreLink/ViewMoreLink';

import { getString } from '../../../helpers/stringHelpers';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

const stringsComponent = 'wellbeing';

class WellbeingLandingCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { classes, title, image, imageAlt, icon, pages, action } = this.props;

    const Icon = icon;

    return (
      <div className={classes.root}>
        <Card className={`${classes.card} Card`}>
          <IndentedCardHeader
            title={
              <React.Fragment>
                <Typography variant='h3' className={classes.titleText}>
                  {title}
                </Typography>
              </React.Fragment>
            }
            avatar={<Icon />}
            classes={{
              avatar: classes.icon,
            }}
          />
          <CardContent className={classes.cardContent}>
            <div>
              {image ? (
                <img
                  src={image}
                  className={classes.image}
                  alt={imageAlt ? imageAlt : ''}
                />
              ) : (
                <Divider className={classes.dividerTop} />
              )}
              {pages.map((page, i, { length }) => {
                return (
                  <div
                    className={classes.contentContainer}
                    key={i}
                    onClick={() => action(page.slug)}
                  >
                    <div className={classes.cardText}>
                      <Typography variant='h4' className={classes.subtitle}>
                        {page.title}
                      </Typography>
                      <Typography>{page.description}</Typography>
                    </div>
                    <div className={classes.buttonContainer}>
                      <ViewMoreLink
                        action={() => action(page.slug)}
                        label={getString(stringsComponent, 'VIEW_MORE_LABEL')}
                        standAlone
                      />
                    </div>
                    {i !== length - 1 && (
                      <Divider className={classes.divider} />
                    )}
                  </div>
                );
              })}
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }
}

WellbeingLandingCard.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  icon: PropTypes.func.isRequired,
  pages: PropTypes.array,
  action: PropTypes.func.isRequired,
};

WellbeingLandingCard.defaultProps = {
  pages: [],
};

export default withStyles(styles)(WellbeingLandingCard);
